import { render } from "./add_new_card_form.vue?vue&type=template&id=842e947a"
import script from "./add_new_card_form.vue?vue&type=script&lang=js"
export * from "./add_new_card_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__